import { LINKS, PRODUCT_CATEGORIES } from '@utils/constants';
import { SVGPicker } from '@utils/helpers';
import { StaticQuery, graphql } from 'gatsby';
import React from 'react';

import Grid from '@components/Layout/Grid/Grid';
import Card from '@components/Molecule/Card/Card';
import H from '@components/Typography/H';

const CategoryListing = ({
	theme = 'standard',
	large,
	grow,
}: {
	theme?: 'standard' | 'dark';
	large?: boolean;
	grow?: boolean;
}) => {
	return (
		<StaticQuery
			query={graphql`
				query {
					category: allPrismicProductCategory {
						edges {
							node {
								uid
								data {
									title
									codename
									image {
										gatsbyImageData
										alt
									}
									content {
										html
									}
									key_feature {
										html
									}
								}
							}
						}
					}
				}
			`}
			render={({ category }: { category: any }): JSX.Element => {
				category.edges.sort(
					(a, b) =>
						PRODUCT_CATEGORIES.indexOf(a.node.data.codename) -
						PRODUCT_CATEGORIES.indexOf(b.node.data.codename)
				);

				return (
					<Grid gap="sm">
						{category.edges.map(
							({ node }: { node: any }, key: number) => {
								const { uid } = node;
								const { title } = node.data;

								return (
									<Card
										id={key}
										to={`${LINKS.PRODUCTS}/${uid}`}
										title={title}
										large={large}
										grow={grow}
										theme={theme}
										svg={title && SVGPicker(uid)}
										key={key}>
										{title && (
											<H level={5} as="h3">
												{title}
											</H>
										)}
									</Card>
								);
							}
						)}
					</Grid>
				);
			}}
		/>
	);
};

export default CategoryListing;
